import React, { useEffect } from 'react'
import {
  Formik,
  Field,
  useFormikContext
} from 'formik'
import {
  Form,
  FormGroup,
  Row,
  Col
} from 'reactstrap'
import * as Yup from 'yup'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import TextInput from 'ui/forms/text_input'

const ReturnColumn = styled.div`
  @media (min-width: 768px) {
    border-left: var(--bs-border-width) solid var(--bs-border-color);
    padding-left: 2rem;
  }
`

const FormObserver = ({ setForm }) => {
  const form = useFormikContext()
  const { values, errors, touched } = form

  useEffect(() => {
    setForm(form)
  }, [values, errors, touched])

  return null
}

const AxisDetailsForm = (props) => {
  const {
    setForm,
    hasReturn = false
  } = props

  const { t, i18n } = useTranslation()

  const requiredMsg = i18n.t(
    'validations:required',
    {
      defaultValue: 'Este campo es obligatorio'
    }
  )

  const optionalString = Yup.string()
    .nullable()
    .notRequired()

  const validationSchema = Yup.object({
    pickup_flight_company_code: Yup.string()
      .required(requiredMsg),

    pickup_flight_company_number: Yup.string()
      .required(requiredMsg),

    pickup_flight_company_time: Yup.string()
      .required(requiredMsg),

    dropoff_flight_company_code: hasReturn
      ? Yup.string().required(requiredMsg)
      : optionalString,

    dropoff_flight_company_number: hasReturn
      ? Yup.string().required(requiredMsg)
      : optionalString,

    dropoff_flight_company_time: hasReturn
      ? Yup.string().required(requiredMsg)
      : optionalString
  })

  return (
    <Formik
      initialValues={{
        pickup_flight_company_code: '',
        pickup_flight_company_number: '',
        pickup_flight_company_time: '',
        dropoff_flight_company_code: '',
        dropoff_flight_company_number: '',
        dropoff_flight_company_time: ''
      }}
      validationSchema={validationSchema}
      validateOnMount
      onSubmit={() => {}}
    >
      {(form) => (
        <>
          <FormObserver setForm={setForm} />

          <Form onSubmit={form.handleSubmit}>
            <Row className="g-4 justify-content-center">
              <Col xs={12} md={6}>
                <FormGroup className="mb-3">
                  <Row className="g-3">
                    <Col xs={12} sm={6}>
                      <Field
                        name="pickup_flight_company_code"
                        label={i18n.t('axis_details_form.airline_company_code')}
                        placeholder={i18n.t('format:html.exemple_placeholder', {text: 'IBE'})}
                        component={TextInput}
                        required
                      />
                    </Col>

                    <Col xs={12} sm={6}>
                      <Field
                        name="pickup_flight_company_number"
                        label={i18n.t('axis_details_form.flight_number')}
                        placeholder={i18n.t('format:html.exemple_placeholder', {text: '123'})}
                        component={TextInput}
                        required
                      />
                    </Col>
                  </Row>
                </FormGroup>

                <FormGroup className="mb-0">
                  <Field
                    name="pickup_flight_company_time"
                    label={i18n.t('axis_details_form.pickup_flight_time')}
                    type="time"
                    component={TextInput}
                    required
                  />
                </FormGroup>
              </Col>

              {hasReturn && (
                <Col xs={12} md={6}>
                  <ReturnColumn>
                    <FormGroup className="mb-3">
                      <Row className="g-3">
                        <Col xs={12} sm={6}>
                          <Field
                            name="dropoff_flight_company_code"
                            label={i18n.t('axis_details_form.airline_company_code')}
                            placeholder={i18n.t('format:html.exemple_placeholder', {text: 'IBE'})}
                            component={TextInput}
                            required
                          />
                        </Col>

                        <Col xs={12} sm={6}>
                          <Field
                            name="dropoff_flight_company_number"
                            label={i18n.t('axis_details_form.flight_number')}
                            placeholder={i18n.t('format:html.exemple_placeholder', {text: '123'})}
                            component={TextInput}
                            required
                          />
                        </Col>
                      </Row>
                    </FormGroup>

                    <FormGroup className="mb-0">
                      <Field
                        name="dropoff_flight_company_time"
                        label={i18n.t('axis_details_form.dropoff_flight_time')}
                        type="time"
                        component={TextInput}
                        required
                      />
                    </FormGroup>
                  </ReturnColumn>
                </Col>
              )}
            </Row>
          </Form>
        </>
      )}
    </Formik>
  )
}

export default AxisDetailsForm
